import React from "react";

import { Add } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";

import {
  IndividualRuleSchema,
  PublishingDaysExceptionSchema,
} from "../../types";
import { GAP, GRID_FOUR_COLUMNS } from "../../utils";

import PublicationDateRow from "./PublicationDateRow";

export interface InclusionsSectionProps {
  rule: IndividualRuleSchema | undefined;
  isEditing: boolean;
  onRuleChange: (newRule: IndividualRuleSchema) => void;
  gap?: number;
  gridTemplateColumns?: string;
}

const InclusionsSection: React.FC<InclusionsSectionProps> = ({
  rule,
  isEditing,
  onRuleChange,
}) => {
  const handleAddInclusion = () => {
    if (rule == null) return;
    const newRule = {
      ...rule,
      inclusions: [...rule.inclusions, { day_name: "", date: "" }],
    };
    onRuleChange(newRule);
  };

  const handleDeleteInclusion = (index: number) => {
    if (rule == null) return;
    const newInclusions = [...rule.inclusions];
    newInclusions.splice(index, 1);
    onRuleChange({
      ...rule,
      inclusions: newInclusions,
    });
  };

  const handleUpdateInclusion = (
    index: number,
    newDate: PublishingDaysExceptionSchema,
  ) => {
    if (rule == null) return;
    const newInclusions = [...rule.inclusions];
    newInclusions[index] = newDate;
    onRuleChange({
      ...rule,
      inclusions: newInclusions,
    });
  };

  return (
    <Box id="included-dates">
      <Typography gutterBottom color="text.secondary" variant="subtitle2">
        Inkluderade utgivningsdagar
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: GRID_FOUR_COLUMNS,
          gap: GAP,
        }}
      >
        {rule?.inclusions.map((date, index) => (
          <PublicationDateRow
            key={date.date}
            initialDate={date}
            isEditing={isEditing}
            onDelete={() => handleDeleteInclusion(index)}
            onUpdate={(newDate) => handleUpdateInclusion(index, newDate)}
          />
        ))}
        {!isEditing && rule?.inclusions.length === 0 && (
          <Typography color="text.secondary" variant="body2">
            Inga inkluderade utgivningsdagar.
          </Typography>
        )}
        {isEditing && (
          <Box>
            <Button startIcon={<Add />} onClick={handleAddInclusion}>
              Lägg till
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default InclusionsSection;
